import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCpu, FiTool, FiServer } = FiIcons;

const industries = [
  {
    icon: FiCpu,
    title: 'Electronics & Robotics',
    description: 'Handle product support calls, warranty inquiries, and technical triage for hardware products. Route complex issues to your engineering team with full context.',
    stat: '~40% After-Hours Calls Missed',
  },
  {
    icon: FiServer,
    title: 'IT Services & MSPs',
    description: 'Answer every support ticket call instantly. Triage by severity, create tickets in your PSA, and route to the right tech — all without a human dispatcher.',
    stat: '60-70% Calls Are Tier-1',
  },
  {
    icon: FiTool,
    title: 'Industrial Equipment',
    description: 'Handle service scheduling, warranty claims, and parts inquiries 24/7. Your field technicians stay in the field. Your customers get instant responses.',
    stat: '$3,500+/mo Per Support Rep',
  },
];

const Industries = () => (
  <section className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Industries We Serve</h2>
        <p className="text-lg text-slate-600">Built for B2B companies with high-volume inbound call operations.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {industries.map((industry, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="bg-white rounded-2xl p-8 border border-slate-100 hover:border-green-200 hover:shadow-lg transition-all duration-300 group"
          >
            <div className="w-14 h-14 bg-slate-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-green-50 transition-colors">
              <SafeIcon icon={industry.icon} className="w-7 h-7 text-slate-700 group-hover:text-green-700 transition-colors" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">{industry.title}</h3>
            <p className="text-slate-600 text-sm leading-relaxed mb-6">{industry.description}</p>
            <div className="inline-block px-3 py-1 bg-slate-100 rounded text-xs font-bold text-slate-600">
              {industry.stat}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Industries;